<template>
    <div>
        <TechnicalHeader
                icon="discernment_license_icon"
                name="车牌识别技术"
                title="对给定的视频（图片）进行检测，并返回视频（图片）中检测到的车牌信息。"
                domId="LicensePlateRecognition"
        />
        <main>
            <div class="technology-area">
                <div class="technology-content">
                    <div class="describe-image-area">
                        <img src="../../assets/images/discernment_license_describe.png" alt="" />
                    </div>
                    <div class="technology-describe-area">
                        <p class="technology-describe-title">技术描述</p>
                        <p class="technology-describe-text">我们对视频（图像）进行详细的分析，准确的返回其中的车牌信息。基于深度神经网络实现的快速、精准、广泛的车牌识别系统。</p>
                        <div class="technology-line"></div>
                    </div>
                </div>
            </div>

            <!-- <div id="demo-content" class="technology-area technology-area-inverse">
              <div class="technology-content">
                <div class="technology-example">
                  <p class="technology-example-title">功能演示</p>
                  <p class="technology-example-text">马上体验鱼住车牌识别能力，请上传一张本地图片或提供图片URL。</p>
                  <form class="technology-form">
                    <button id="upload-file-button" class="title-button title-button-primary upload-btn" type="button">
                      <i class="fa fa-cloud-upload"></i>
                      <span data-locale="upload">立即上传</span>
                    </button>
                    <div class="upload-file-box-area">
                      <input accept="image/jpeg,image/jpg,image/png" class="upload-file-box" type="file" name="">
                    </div>
                    <div class="technology-form-group">
                      <input id="upload-file-url-box" data-placeholder="imageBox" class="upload-file-url-box" placeholder="图片URL" type="tetx" name="">
                    </div>
                    <div id="verification-code-area" class="verification-code-area">
                      <div class="verification-code-box-area">
                        <input id="verification-code-box" data-placeholder="verificationCodeBox" placeholder="请输入验证码" type="text" name="">
                        <p id="verification-code-message" class="verification-code-message"></p>
                      </div>
                      <div class="verification-image-area">
                        <img id="verification-code-image" alt="验证码" src="">
                        <a id="refresh-verification-code" href="javascript:void(0)">看不清，换一张</a>
                      </div>
                      <div class="verification-btn-area">
                        <button id="cancel-verification-code" class="btn btn-default" type="button">取消</button>
                        <button id="save-verification-code" class="btn btn-primary" type="button">确定</button>
                      </div>
                    </div>
                  </form>
                  <p class="example-prompt">您也可以选择下面图片，系统将自动进行识别。</p>

                  <div class="example-image-area">
                    <img class="active" src="../../assets/images/discernment_license_example1.png">
                    <img src="../../assets/images/discernment_license_example2.png?v=1.1">
                    <img src="../../assets/images/discernment_license_example3.png">
                    <img src="../../assets/images/discernment_license_example4.png">
                  </div>
                </div>
                <div class="technology-example-result">
                  <div class="result-image-area">
                    <div class="result-content-area">
                      <img id="result-image" src="../../assets/images/discernment_license_example3.png">
                      <button id="result-data-btn" type="button" class="result-data-btn">Response JSON</button>
                      <div id="result-show-area" class="result-show-area"></div>
                      <div id="face-check-message" class="face-check-message"></div>
                      <div class="loading-area">
                        <div class="loadEffect">
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="result-data-area">
                    <pre id="result-data"></pre>
                    <button id="result-data-back-btn" type="button" class="result-data-back-btn"><i class="fa fa-remove"></i></button>
                  </div>
                </div>
              </div>
            </div> -->

            <div class="technology-area">
                <div class="technology-content">
                    <p class="technology-scene-title">应用场景</p>
                    <ul class="technology-scene-list">
                        <li data-code="0" class="active">
                            <span>车辆检测报警</span>
                            <div class="scene-line"></div>
                        </li>
                        <li data-code="1">
                            <span>牌照号码自动登记</span>
                            <div class="scene-line"></div>
                        </li>
                        <li data-code="2">
                            <span>车辆出入管理</span>
                            <div class="scene-line"></div>
                        </li>
                    </ul>

                    <div class="scene-image-area">
                        <img src="../../assets/images/discernment_license_scene1.png">
                        <img src="../../assets/images/discernment_license_scene2.png">
                        <img src="../../assets/images/discernment_license_scene3.png">
                    </div>
                </div>
            </div>

            <div class="technology-area technology-buy-area">
                <div class="technology-content">
                    <p class="technology-buy-title">即刻拥有鱼住车牌识别技术</p>
                    <p class="technology-buy-text">享受更高的性价比和技术优势</p>
<!--                    <a href="price.html" class="buy-btn">立即购买</a>-->
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    import TechnicalHeader from '@/components/TechnicalHeader.vue';
    export default {
        name: "DiscernmentLicencePlate",
        data: function () {
            return {
                code: 0
            };
        },
        mounted: function () {
            let self = this;
            $(".technology-scene-list li").on("click", function () {
                let code = $(this).data("code");
                if (code != self.code) {
                    $(".technology-scene-list li.active").removeClass("active");
                    $(this).addClass("active");
                    $(".scene-image-area").find("img").fadeOut(500).eq(code).fadeIn(500);
                    self.code = code
                }
            })
        },
        components: {
            TechnicalHeader
        }
    }
</script>

<style scoped>
    @import "../../assets/css/face_common.css";
    .technology-title-area{
        background: url(../../assets/images/discernment_license_bg.png) center no-repeat;
        background-size: cover;
    }
    .technology-scene-list{
        width: 600px;
    }
    .face-check-message p{
        margin-bottom: 0px;
    }
</style>
